import { mockCodeAgent } from '../agents';
import { mockConversations } from '../conversations';
import { makeStreamStart, makeBlockStart, makeBlockEnd, makeBlockComplete, makeStreamEnd, splitTextIntoDeltas } from '../sseEvents';
const RESPONSE_ID = 'resp-nfpa';
const CONV_ID = 'conv-3';
const MD_BLOCK_ID = 'blk-nfpa-md';
const CITATION_BLOCK_ID = 'blk-nfpa-cite';
const DISCLAIMER_BLOCK_ID = 'blk-nfpa-disc';
const markdownText = 'According to **NFPA 25 (2023 Edition)**, Section 5.2.1, sprinkler systems shall be inspected ' +
    'from the floor level annually. The inspector shall verify that sprinklers are free of corrosion, ' +
    'foreign materials, paint, and physical damage, and that they are installed in the correct orientation.';
const citationBlock = {
    type: 'markdown',
    block_id: CITATION_BLOCK_ID,
    block_index: 1,
    content: '> **NFPA 25 §5.2.1** — Sprinklers shall be inspected from the floor level annually. ' +
        'Sprinklers shall be free of corrosion, foreign materials, paint, and physical damage ' +
        'and shall be installed in the correct orientation (e.g., upright, pendent, or sidewall).\n\n' +
        '*Source: NFPA 25 — Standard for the Inspection, Testing, and Maintenance of Water-Based Fire Protection Systems, 2023 Edition*'
};
const disclaimerBlock = {
    type: 'markdown',
    block_id: DISCLAIMER_BLOCK_ID,
    block_index: 2,
    content: '---\n\n' +
        '⚠️ **Disclaimer**: This is an AI-generated summary of fire code requirements. ' +
        'Always consult the official NFPA documentation and your local Authority Having Jurisdiction (AHJ) ' +
        'for definitive compliance guidance.'
};
const sseSequence = [
    makeStreamStart(RESPONSE_ID, CONV_ID, mockCodeAgent),
    makeBlockStart(MD_BLOCK_ID, 0, 'markdown'),
    ...splitTextIntoDeltas(MD_BLOCK_ID, markdownText, 20, 25),
    makeBlockEnd(MD_BLOCK_ID),
    makeBlockComplete(citationBlock, 80),
    makeBlockComplete(disclaimerBlock, 60),
    makeStreamEnd(RESPONSE_ID, 3, mockCodeAgent)
];
export const scenario = {
    name: 'Fire Code Expert — NFPA Lookup',
    description: 'NFPA citation response with streaming markdown, then atomic citation and disclaimer blocks.',
    conversations: mockConversations,
    userMessage: 'What are the NFPA 25 sprinkler inspection requirements?',
    agentIdentity: mockCodeAgent,
    sseSequence
};
